<template>
    <div class="RequestPermission" @touchstart="onClick()" @click="onClick()">
        <div class="RequestPermission__sentence">{{ trans('sentence') }}</div>
        <div class="Btn">{{ trans('button') }}</div> 
    </div>
</template>

<script>
import * as BABYLON from 'babylonjs'

export default {
  name: 'RequestPermission',
  translations: {
    fr: { 
        button: 'Activer', 
        sentence: 'Activer le gyroscope pour commencer' 
    },
    en: { 
        button: 'Activate', 
        sentence: 'Activate the gyroscope to start' 
    },
  },
  methods: {
    onClick() {
        if (typeof DeviceMotionEvent.requestPermission === 'function') {
            DeviceMotionEvent.requestPermission()
                .then(permissionState => {
                    if (permissionState === 'granted') {
                        this.$store.commit('app/UPDATE_REQUEST', false)
                    }
                })
                .catch(console.error);
        }
    },
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.RequestPermission
    position absolute
  
    padding 24px 24px 32px
    background black
    z-index 999999
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    display flex
    flex-direction column
    justify-content center
    align-items center

    font-size 16px
    font-weight 500
    border-radius 8px

    &__sentence 
        padding-bottom 16px

    & .Btn 
        position relative
        bottom auto
        right auto


</style>



// WEBPACK FOOTER //
// src/components/controls/RequestPermission.vue